import React from 'react';
import { X, AlertTriangle, Info } from 'lucide-react';
export interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: 'danger' | 'warning' | 'default';
}
export function ConfirmModal({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  variant = 'default'
}: ConfirmModalProps) {
  if (!isOpen) return null;
  const getVariantStyles = () => {
    switch (variant) {
      case 'danger':
        return {
          icon: <AlertTriangle className="h-6 w-6 text-red-600" data-id="element-1554" data-mp="ctmgthpxdv8n" />,
          iconBg: 'bg-red-100',
          buttonBg: 'bg-red-600 hover:bg-red-700 focus:ring-red-500'
        };
      case 'warning':
        return {
          icon: <AlertTriangle className="h-6 w-6 text-yellow-600" data-id="element-1555" data-mp="2emiyhnecbw1q" />,
          iconBg: 'bg-yellow-100',
          buttonBg: 'bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500'
        };
      default:
        return {
          icon: <Info className="h-6 w-6 text-blue-600" data-id="element-1556" data-mp="3tl978zems68r" />,
          iconBg: 'bg-blue-100',
          buttonBg: 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500'
        };
    }
  };
  const styles = getVariantStyles();
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" data-id="element-1557" data-mp="3frqbrm8rdxpt">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md overflow-hidden" data-id="element-1558" data-mp="3fpx361el53f6">
        <div className="flex justify-between items-center p-4 border-b border-gray-100" data-id="element-1559" data-mp="gaijnj6kyvhg">
          <div className="flex items-center gap-3" data-id="element-1560" data-mp="cbswwzznk1l5">
            <div className={`p-2 rounded-full ${styles.iconBg}`} data-id="element-1561" data-mp="7bexu7g141z9">
              {styles.icon}
            </div>
            <h3 className="text-lg font-semibold text-gray-900" data-id="element-1562" data-mp="2bsbn8i83beb">{title}</h3>
          </div>
          <button onClick={onCancel} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-1563" data-mp="2s2fhmnlwz1kn">
            <X className="h-5 w-5" data-id="element-1564" data-mp="2n1rfp6w5d0bn" />
          </button>
        </div>
        <div className="p-6" data-id="element-1565" data-mp="2olazxnkappfl">
          <p className="text-gray-600" data-id="element-1566" data-mp="2ol16tr3yf25o">{message}</p>
        </div>
        <div className="flex justify-end gap-3 p-4 border-t border-gray-100 bg-gray-50" data-id="element-1567" data-mp="2tjksrrijsdy1">
          <button onClick={onCancel} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500" data-id="element-1568" data-mp="2fkct6xih33tb">
            {cancelLabel}
          </button>
          <button onClick={onConfirm} className={`px-4 py-2 text-sm font-medium text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 ${styles.buttonBg}`} data-id="element-1569" data-mp="2akqe0ij33dhv">
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>;
}